import React, { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCheck, BellOff } from "lucide-react";
import { api } from "@/lib/api";
import { useMobile } from "./MobileApp";
import { AlertCard, Empty, Spinner, TIPO_UI } from "./ui";

export default function Alertas() {
  const { me, storeId, reload } = useMobile();
  const [sp, setSp] = useSearchParams();
  const tipo = sp.get("tipo") || "";
  const [rows, setRows] = useState(null);
  const [noLeidas, setNoLeidas] = useState(false);

  const load = useCallback(() => api.get("/mobile/alertas", { params: { tipo: tipo || undefined, store_id: storeId || undefined, no_leidas: noLeidas || undefined, limit: 100 } })
    .then((r) => setRows(r.data.alertas)), [tipo, storeId, noLeidas]);
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, [load]);

  const leerTodas = async () => { await api.post("/mobile/alertas/leer", {}); await load(); reload(); };
  const leer = async (a) => { if (!a.leida) { await api.post("/mobile/alertas/leer", { ids: [a.alert_id] }); load(); reload(); } };
  const tipos = me.tipos.filter((t) => !t.pro || me.tier === "PRO");

  return (
    <div className="pt-5" data-testid="mobile-alertas">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold font-display">Alertas</h1>
        <button onClick={leerTodas} data-testid="alertas-leer-todas" className="flex items-center gap-1.5 text-xs text-cyan-300 font-semibold"><CheckCheck className="w-4 h-4" />Marcar leídas</button>
      </div>
      <p className="text-xs text-slate-400 mt-1">Historial de {me.historial_dias} días{me.tier !== "PRO" ? " (12 meses en Pro)" : ""}</p>
      <div className="mt-4 -mx-4 px-4 flex gap-2 overflow-x-auto no-scrollbar pb-1" data-testid="alertas-filtros">
        <button onClick={() => setNoLeidas(!noLeidas)} data-testid="alertas-filtro-no-leidas"
                className={`shrink-0 px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors duration-200 ${noLeidas ? "bg-cyan-500/20 text-cyan-300 border-cyan-400/40" : "border-white/10 text-slate-400"}`}>No leídas</button>
        {[{ tipo: "", label: "Todas" }, ...tipos].map((t) => (
          <button key={t.tipo || "all"} onClick={() => setSp(t.tipo ? { tipo: t.tipo } : {})} data-testid={`alertas-filtro-${t.tipo || "todas"}`}
                  className={`shrink-0 px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors duration-200 ${tipo === t.tipo ? "bg-white text-slate-900 border-white" : "border-white/10 text-slate-400"}`}>
            {t.tipo ? (TIPO_UI[t.tipo]?.label || t.label).toLowerCase().replace(/^\w/, (c) => c.toUpperCase()) : "Todas"}
          </button>
        ))}
      </div>
      <div className="mt-4 space-y-2">
        {!rows ? <Spinner /> : rows.length ? rows.map((a, i) => <AlertCard key={a.alert_id} a={a} i={Math.min(i, 8)} onClick={() => leer(a)} />)
          : <Empty icon={BellOff}>No hay alertas con este filtro.</Empty>}
      </div>
    </div>
  );
}
